import {
    APIProvider,
    Map as GoogleMap,
    Marker,
} from "@vis.gl/react-google-maps";

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_kEY;

export default function Map({ locationData }) {
    if (!locationData?.lat || !locationData?.lon) return null;

    const center = {
        lat: parseFloat(locationData.lat),
        lng: parseFloat(locationData.lon),
    };

    return (
        <div style={{ height: "300px", width: "100%", borderRadius: "8px" }}>
            <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
                <GoogleMap
                    defaultCenter={center}
                    defaultZoom={15}
                    mapTypeControl={false}
                    streetViewControl={false}
                    fullscreenControl={false}
                    zoomControl
                    gestureHandling="greedy"
                >
                    <Marker position={center} title={locationData.name} />
                </GoogleMap>
            </APIProvider>
        </div>
    );
}
